import VueRouter from 'vue-router';

// Vue Templates
import Home from '@/views/Home.vue';
import HomeB from '@/views/HomeB.vue';

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
    },
    {
        path: '/b',
        name: 'HomeB',
        component: HomeB,
    },
];

const router = new VueRouter({
    base: '/',
    mode: 'history',
    routes,
});

export default router;
